import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Col, Form, Modal, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import CustomInput from "../../../CustomControls/CustomInput";
import { post, postFormData } from "../../../helpers/api_helper";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";

import moment from "moment";
import {
  errorMessage,
  successMessage,
  warningMessage,
} from "../CommonFunctions";
import CustomSelect from "../../../CustomControls/CustomSelect";
import {
  POST_GetTestMasterEffectiveDateDDLList,
  POST_GetTestMasterRateList,
  POST_TestMasterRateInsert,
  POST_TestMasterRateListExport,
  POST_TestMasterRateListImportValidateInsert,
} from "../../../helpers/url_helper";

import CommonTestMasterRate from "./CommonTestMasterRate";

const TestMasterRate = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  const [effectiveDateOptions, setEffectiveDateOptions] = useState([]);

  const validationSchema = Yup.object().shape({
    EffectiveDate: Yup.string()
      .trim()
      .required("Effective Date is required field"),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      ListOfTestDepartments: [],
      EffectiveDate: new Date(),
      EffectiveDateID: "",
      RewiseType: 2,
      IsRewise: false,
      IsBackDate: false,
      //IsCurrentEffectiveDate: false,
      TestSearch: "",
      DepartmentIDs: "",
      //TestMasterRateType: 1,
    },
    validateOnBlur: false,
  });

  const {
    values: {
      ListOfTestDepartments,
      EffectiveDate,
      RewiseType,
      IsRewise,
      EffectiveDateID,
      IsBackDate,
      //IsCurrentEffectiveDate,
      TestSearch,
      DepartmentIDs,
      //TestMasterRateType,
    },
  } = formik;

  const handleValidSubmit = (values) => {
    // if (values?.ListOfTest?.filter((x) => x.TestRate > 0)?.length == 0) {
    //   formik.setFieldError("ListOfTest", " Atleast one Test Rate is required");
    //   formik.setFieldTouched("ListOfTest", true);
    //   return;
    // }

    setIsLoading(true);

    let TestList = [];
    let TestParameterList = [];
    let MoreTestRatesList = [];

    values?.ListOfTestDepartments?.map((item) => {
      item?.ListOfTest?.map((subitem) => {
        TestList = [
          ...TestList,
          {
            TestMasterIDEncrypt: subitem?.TestMasterIDEncrypt,
            TestMasterRateIDEncrypt: subitem?.TestMasterRateIDEncrypt,
            EffectiveDate: values?.EffectiveDate
              ? moment(values?.EffectiveDate)
                  .format("YYYY-MM-DD")
                  .replace(/^\-/, "")
              : "",
            TestRate: `${subitem?.TestRate ?? "0"}`, //item?.TestRate ? item?.TestRate : "0",
          },
        ];
      });
    });

    values?.ListOfTestDepartments?.map((item) => {
      item?.ListOfTest?.map((itemSub) => {
        itemSub?.ListOfTestParameter?.map((subitem) => {
          TestParameterList = [
            ...TestParameterList,
            {
              TestParameterRateIDEncrypt: subitem?.TestParameterRateIDEncrypt,
              RefParameterIDEncrypt: subitem?.RefParameterIDEncrypt,
              TestMasterIDEncrypt: subitem?.TestMasterIDEncrypt,
              ParameterName: subitem?.ParameterName,
              ParameterType: subitem?.ParameterType,
              ParameterRate: `${subitem?.ParameterRate ?? "0"}`,
            },
          ];
        });
      });
    });

    values?.ListOfTestDepartments?.map((item) => {
      item?.ListOfTest?.map((itemSub) => {
        itemSub?.ListOfMoreTestRates?.map((subitem) => {
          MoreTestRatesList = [
            ...MoreTestRatesList,
            {
              TestMasterDefineMoreRatesIDEncrypt:
                subitem?.TestMasterDefineMoreRatesIDEncrypt,
              TestMasterIDEncrypt: itemSub?.TestMasterIDEncrypt,
              RateType: subitem?.RateType ? subitem?.RateType : 0,
              Unit: subitem?.Unit ? subitem?.Unit : 0,
              // MinValue: subitem?.MinValue ? subitem?.MinValue.toString() : "",
              MinValue: subitem?.MinValue
                ? subitem?.MinValue.toString()
                : subitem?.MaxValue
                ? ""
                : "",
              MaxValue: subitem?.MaxValue ? subitem?.MaxValue.toString() : "",
              TestRate: subitem?.TestRate
                ? subitem?.TestRate.toString()
                : "0.00",
              IsDeleted: subitem?.IsDeleted,
              IsIncudeStandardRate: subitem?.IsIncudeStandardRate,
            },
          ];
        });
      });
    });

    let payload = {
      EffectiveDate: values?.EffectiveDate
        ? moment(values?.EffectiveDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      CreatedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
      ListOfTest: TestList,
      ListOfTestParameter: TestParameterList,
      ListOfMoreTestRates: MoreTestRatesList,
    };

    //console.log("payload", payload);
    //return;

    post(POST_TestMasterRateInsert, payload)
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          successMessage(response?.Message);
          setTimeout(() => {
            navigate("/dashboard");
          }, 1000);
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    formik.setFieldValue("RewiseType", 2);
    getEffectiveDateDDL();
  }, []);

  useEffect(() => {
    if (!EffectiveDate) {
      formik.setFieldValue("EffectiveDate", "");
    }
  }, [EffectiveDate]);

  const getEffectiveDateDDL = async () => {
    setIsLoading(true);
    await post(POST_GetTestMasterEffectiveDateDDLList, {
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setEffectiveDateOptions(
            response?.ListOfEffectiveDate?.map((item) => ({
              label: item?.EffectiveDate,
              value: item?.EffectiveDate,
              IsBackDate: item?.IsBackDate,
              IsCurrentEffectiveDate: item?.IsCurrentEffectiveDate,
            }))
          );

          if (response?.ListOfEffectiveDate?.length > 0) {
            formik.setFieldValue(
              "IsBackDate",
              response?.ListOfEffectiveDate[0].IsBackDate
            );

            formik.setFieldValue(
              "EffectiveDateID",
              response?.ListOfEffectiveDate[0].EffectiveDate
            );

            formik.setFieldValue(
              "EffectiveDate",
              response?.ListOfEffectiveDate[0].EffectiveDate
            );

            GetTestList(response?.ListOfEffectiveDate[0].EffectiveDate, 2);
          } else {
            formik.setFieldValue("EffectiveDate", new Date());
            formik.setFieldValue("RewiseType", 1);
            formik.setFieldValue("IsBackDate", false);
            GetTestList("", 1);
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const GetTestList = async (SelectedDate, RType) => {
    setIsLoading(true);
    await post(POST_GetTestMasterRateList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      EffectiveDate: SelectedDate,
      RewiseType: RType,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          if (response?.ListOfTestDepartments?.length > 0) {
            formik.setValues({
              ListOfTestDepartments: response?.ListOfTestDepartments?.map(
                (item) => ({
                  DepartmentIDEncrypt: item?.DepartmentIDEncrypt,
                  DepartmentName: item?.DepartmentName,
                  display: true,
                  ListOfTest: item?.ListOfTest?.map((itemsub) => ({
                    TestMasterRateIDEncrypt: itemsub?.TestMasterRateIDEncrypt,
                    TestMasterIDEncrypt: itemsub?.TestMasterIDEncrypt,
                    TestName: itemsub?.TestName,
                    TestRate: itemsub?.TestRate,
                    EffectiveDate: itemsub?.EffectiveDate,
                    display: true,
                    ListOfTestParameter: itemsub?.ListOfTestParameter,
                    ListOfMoreTestRates: itemsub?.ListOfMoreTestRates?.map(
                      (itemsubRate) => ({
                        TestMasterDefineMoreRatesIDEncrypt:
                          itemsubRate?.TestMasterDefineMoreRatesIDEncrypt,
                        TestMasterIDEncrypt: itemsub?.TestMasterIDEncrypt,
                        RateType: itemsubRate?.RateType,
                        Unit: itemsubRate?.Unit,
                        MinValue: itemsubRate?.MinValue,
                        MaxValue: itemsubRate?.MaxValue,
                        TestRate: itemsubRate?.TestRate,
                        IsDeleted: false,
                        IsIncudeStandardRate: itemsubRate?.IsIncudeStandardRate,
                      })
                    ),
                  })),
                })
              ),
            });

            formik.setFieldValue("RewiseType", RType);
            formik.setFieldValue("IsRewise", RType == 2 ? false : true);

            if (RType == 1) {
              if (effectiveDateOptions?.length > 0) {
                formik.setFieldValue("EffectiveDate", new Date(SelectedDate));
              } else {
                formik.setFieldValue("IsBackDate", false);
                formik.setFieldValue("EffectiveDate", new Date());
              }
            }

            if (SelectedDate) {
              formik.setFieldValue("EffectiveDate", new Date(SelectedDate));
              formik.setFieldValue("EffectiveDateID", SelectedDate);
            }

            const today = new Date();
            const effectiveDate = new Date(SelectedDate);
            today.setHours(0, 0, 0, 0);
            effectiveDate.setHours(0, 0, 0, 0);

            if (effectiveDate >= today) {
              formik.setFieldValue("IsBackDate", false);
            } else {
              if (effectiveDateOptions?.length == 1) {
                formik.setFieldValue("IsBackDate", false);
                formik.setFieldValue("EffectiveDate", "");
              } else {
                formik.setFieldValue("IsBackDate", true);
              }
            }

            if (
              effectiveDateOptions?.length ==
              effectiveDateOptions?.filter((x) => x.IsBackDate == true)?.length
            ) {
              formik.setFieldValue("IsBackDate", false);
              formik.setFieldValue("EffectiveDate", "");
            }
          } else {
            formik.setFieldValue("ListOfTestDepartments", []);
          }
        } else {
          formik.setFieldValue("ListOfTestDepartments", []);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const exportReport = () => {
    setIsLoading(true);
    let payload = {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
      EffectiveDate: EffectiveDate
        ? moment(EffectiveDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : EffectiveDateID,
      RewiseType: RewiseType,
      DepartmentIDs: DepartmentIDs
        ? Array.from(DepartmentIDs, (x) => x.value).join(",")
        : "",
      TestName: TestSearch,
    };
    post(POST_TestMasterRateListExport, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          window.open(response?.FilePath);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const [testMasterRateImportModal, setTestMasterRateImportModal] =
    useState(false);
  const TestMasterRateImport = () => {
    formikTestMasterRateImport.resetForm();
    setTestMasterRateImportModal(true);
  };

  const validationSchemaTestMasterRateImport = Yup.object().shape({});

  const formikTestMasterRateImport = useFormik({
    validationSchema: validationSchemaTestMasterRateImport,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitTestMasterRateImport(values, formikHelpers),
    initialValues: {
      UploadFile: "",
      FileFormatPath: "",
      ListOfData: [],
      UploadFileKey: "",
      btnSubmitType: "",
      TotalRecords: 0,
      ValidCount: 0,
      InValidRecords: 0,
      btnSubmitType: "",
      InValidRecordsFilePath: "",
      ValidRecordsFilePath: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {
      ListOfData,
      UploadFile,
      FileFormatPath,
      UploadFileKey,
      btnSubmitType,
      TotalRecords,
      ValidCount,
      InValidRecords,
      InValidRecordsFilePath,
      ValidRecordsFilePath,
    },
  } = formikTestMasterRateImport;

  const handleValidSubmitTestMasterRateImport = (values) => {
    formikTestMasterRateImport.setFieldValue("ListOfData", []);

    if (!values?.UploadFile) {
      warningMessage("Please select Excel file");
      return;
    }

    setIsLoading(true);
    let formData = new FormData();

    formData.append("CompanyIDEncrypted", AuthUser?.CompanyIDEncrypt);
    formData.append("BranchIDEncrypted", AuthUser?.BranchIDEncrypt);
    formData.append(
      "EffectiveDate",
      EffectiveDate
        ? moment(EffectiveDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : EffectiveDateID
    );
    formData.append("ImportFile", values?.UploadFile);
    formData.append(
      "CreatedByEncrypted",
      AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0"
    );
    formData.append("ImportType", values?.btnSubmitType);

    //
    postFormData(POST_TestMasterRateListImportValidateInsert, formData)
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          formikTestMasterRateImport.setFieldValue(
            "ListOfData",
            response?.List
          );
          formikTestMasterRateImport.setFieldValue(
            "InValidRecords",
            response?.InValidRecords
          );
          formikTestMasterRateImport.setFieldValue(
            "ValidCount",
            response?.ValidCount
          );
          formikTestMasterRateImport.setFieldValue(
            "TotalRecords",
            response?.TotalRecords
          );
          formikTestMasterRateImport.setFieldValue(
            "InValidRecordsFilePath",
            response?.InValidRecordsFilePath
          );
          formikTestMasterRateImport.setFieldValue(
            "ValidRecordsFilePath",
            response?.ValidRecordsFilePath
          );

          if (values?.btnSubmitType == 1) {
            successMessage("File Validate....!!!");
          } else {
            successMessage("File Uploaded....!!!");
            formik.setFieldValue("RewiseType", 2);
            getEffectiveDateDDL();
            setTestMasterRateImportModal(false);
          }
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
          formikTestMasterRateImport.setFieldValue("ListOfData", "");
          formikTestMasterRateImport.setFieldValue("InValidRecords", 0);
          formikTestMasterRateImport.setFieldValue("ValidCount", 0);
          formikTestMasterRateImport.setFieldValue("TotalRecords", 0);
          formikTestMasterRateImport.setFieldValue(
            "InValidRecordsFilePath",
            ""
          );
          formikTestMasterRateImport.setFieldValue("ValidRecordsFilePath", "");
          formikTestMasterRateImport.setFieldValue("UploadFile", "");
          formikTestMasterRateImport.setFieldValue(
            "UploadFileKey",
            Math.random().toString(9).substring(2, 9)
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const uploadUploadMasterFile = (e) => {
    if (e?.target?.files[0]) {
      const file = e?.target?.files[0];
      const fileType = file.type;
      const validFileTypes = [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
      ]; // MIME types for Excel files

      if (!validFileTypes.includes(fileType)) {
        warningMessage("Please select a valid Excel file (.xlsx or .xls)");
        formikTestMasterRateImport.setFieldValue("UploadFile", "");
        formikTestMasterRateImport.setFieldValue(
          "UploadFileKey",
          Math.random().toString(9).substring(2, 9)
        );
      } else {
        formikTestMasterRateImport.setFieldValue("UploadFile", file);
      }
    }
  };

  return (
    <>
      <div className="card m-1">
        <div className="card-body p-1">
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div className="table-responsive active-projects style-1 shorting">
              <div className="tbl-caption p-2">
                <h4 className="heading mb-0">Test Master Rate</h4>
                <div className="d-flex align-items-center">
                  {AuthUser?.UserType !== 1 ||
                  formsList?.filter((x) => x?.FormID == 22 && x?.IsExport)
                    ?.length > 0 ? (
                    <>
                      <Link
                        className="btn btn-outline-primary btn-sm me-2"
                        title="Export"
                        onClick={exportReport}
                      >
                        <i className="fa-solid fa-file-excel" /> Export
                      </Link>
                      {RewiseType == 1 ? (
                        EffectiveDate ? (
                          IsBackDate == false ? (
                            <Link
                              className="btn btn-outline-primary btn-sm me-2"
                              title="Import"
                              onClick={() => {
                                TestMasterRateImport();
                              }}
                            >
                              <i className="fa-solid fa-file-excel" /> Import
                            </Link>
                          ) : (
                            ""
                          )
                        ) : (
                          ""
                        )
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
            <hr className="mt-0 mb-1"></hr>
            <div className="p-2 pt-0">
              <FormikProvider value={formik}>
                <Form onSubmit={formik.handleSubmit}>
                  {effectiveDateOptions?.length > 0 ? (
                    <>
                      <Row>
                        {RewiseType == 1 ? (
                          <Col lg={2}>
                            {IsBackDate ? (
                              <Field
                                label="EffectiveDate"
                                name="EffectiveDate"
                                component={CustomInput}
                                value={moment(EffectiveDate).format(
                                  "DD-MMM-yyyy"
                                )}
                                disabled={true}
                              />
                            ) : (
                              <Field
                                label="Effective Date"
                                name="EffectiveDate"
                                placeholder={"Select Effective Date"}
                                component={CustomFlatpickr}
                                options={{
                                  altInput: true,
                                  altFormat: "j-M-Y",
                                  dateFormat: "d-m-Y",
                                  minDate: "today",
                                }}
                                autoFocus
                              />
                            )}
                          </Col>
                        ) : (
                          ""
                        )}
                        <Col lg={2}>
                          <Field
                            label="Date"
                            name="EffectiveDateID"
                            placeholder={"Select Effective Date"}
                            options={effectiveDateOptions}
                            component={CustomSelect}
                            //menuPosition="fixed"
                            isClearable={false}
                            onChange={(e) => {
                              formik.setFieldValue("EffectiveDateID", e?.value);
                              formik.setFieldValue("IsBackDate", e?.IsBackDate);
                              GetTestList(e?.value, RewiseType);
                            }}
                          />
                        </Col>
                        <Col lg={3}>
                          <label></label>
                          <div className="d-flex mb-2">
                            <label>Revise &nbsp;</label>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="flexSwitchCheckChecked"
                                checked={IsRewise}
                                onChange={(e) => {
                                  formik.setFieldValue(
                                    "IsRewise",
                                    e?.target?.checked
                                  );
                                  if (e?.target?.checked == true) {
                                    formik.setFieldValue("RewiseType", 1);
                                    GetTestList(EffectiveDateID, 1);
                                  } else {
                                    formik.setFieldValue("RewiseType", 2);
                                    GetTestList(EffectiveDateID, 2);
                                  }
                                }}
                                style={{ cursor: "pointer" }}
                              ></input>
                            </div>
                          </div>
                        </Col>
                      </Row>
                      {RewiseType == 1 && IsBackDate ? (
                        <Row>
                          {/* <div>
                            <label style={{ color: "red" }}>
                              Selected Date is Past Date can't not be update any
                              Rate
                            </label>
                          </div> */}
                        </Row>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    <Row>
                      <Col lg={2}>
                        <Field
                          label="Effective Date"
                          name="EffectiveDate"
                          placeholder={"Select Effective Date"}
                          component={CustomFlatpickr}
                          options={{
                            altInput: true,
                            altFormat: "j-M-Y",
                            dateFormat: "d-m-Y",
                            minDate: "today",
                          }}
                          autoFocus
                        />
                      </Col>
                    </Row>
                  )}

                  <hr className="mt-0 mb-1"></hr>
                  <Row>
                    <Col lg={12}>
                      <CommonTestMasterRate />
                    </Col>
                  </Row>
                  <div className="stickyBottomButtons">
                    <hr className="mt-1 mb-2"></hr>
                    {RewiseType == 1 && IsBackDate == false ? (
                      <button
                        type="submit"
                        className="btn btn-primary btn-sm me-2"
                      >
                        <i className="fa-solid fa-floppy-disk"></i> Submit
                      </button>
                    ) : (
                      ""
                    )}
                    <button
                      type="button"
                      className="btn btn-danger btn-sm"
                      onClick={(e) => {
                        navigate("/dashboard");
                      }}
                    >
                      <i className="fa fa-cancel"></i> Cancel
                    </button>
                  </div>
                </Form>
              </FormikProvider>
            </div>
          </Spin>
          <Modal
            className="fade"
            show={testMasterRateImportModal}
            onHide={setTestMasterRateImportModal}
            size="xl"
          >
            <Spin
              size="large"
              spinning={isLoading}
              tip={"Loading..."}
              style={{ position: "fixed" }}
            >
              <FormikProvider value={formikTestMasterRateImport}>
                <Form onSubmit={formikTestMasterRateImport.handleSubmit}>
                  <Modal.Header>
                    <Modal.Title>Test Master Rate Import</Modal.Title>
                    <button
                      type="button"
                      variant=""
                      className="btn-close"
                      onClick={() => setTestMasterRateImportModal(false)}
                    ></button>
                  </Modal.Header>
                  <Modal.Body>
                    <Row>
                      <Col lg={6}>
                        <div className="d-flex justify-content-between">
                          <label className="mb-1">
                            Upload File <span className="text-danger">*</span>
                          </label>
                        </div>

                        <input
                          type="file"
                          id="UploadFile"
                          accept=".xlsx, .xls"
                          className="form-control form-control-sm"
                          key={UploadFileKey || ""}
                          onChange={(e) => {
                            uploadUploadMasterFile(e);
                          }}
                        />
                        <ErrorMessage
                          name="UploadFile"
                          component="div"
                          className="invalid-feedback animated fadeInUp"
                          style={{ display: "block" }}
                        />
                      </Col>
                      <Col lg={6}>
                        <label className="mb-1"></label>
                        <button
                          type="submit"
                          className="btn btn-primary btn-sm me-2 mt-4"
                          onClick={() => {
                            formikTestMasterRateImport.setFieldValue(
                              "btnSubmitType",
                              1
                            );
                          }}
                        >
                          <i className="fa-solid fa-floppy-disk"></i> Validate
                        </button>
                        <button
                          type="submit"
                          className="btn btn-primary btn-sm me-2 mt-4"
                          onClick={() => {
                            formikTestMasterRateImport.setFieldValue(
                              "btnSubmitType",
                              2
                            );
                          }}
                        >
                          <i className="fa-solid fa-floppy-disk"></i> Import
                        </button>

                        <button
                          type="button"
                          className="btn btn-danger btn-sm mt-4"
                          onClick={() => {
                            setTestMasterRateImportModal(false);
                          }}
                        >
                          <i className="fa fa-cancel"></i> Cancel
                        </button>
                      </Col>
                    </Row>
                    {UploadFile ? (
                      <Row>
                        <div className="d-flex">
                          <div style={{ width: "100%" }}>
                            <div className="bootstrap-badge pt-2">
                              <label
                                className="me-1 badge-success badge p-1"
                                style={{ color: "#ffffff", minWidth: "100px" }}
                              >
                                Total Records : {TotalRecords}
                              </label>
                              <label
                                className="me-1 badge-warning badge p-1"
                                style={{ color: "#ffffff", minWidth: "100px" }}
                              >
                                Valid Count : {ValidCount}
                              </label>
                              <label
                                className="me-1 badge-danger badge p-1"
                                style={{ color: "#ffffff", minWidth: "100px" }}
                              >
                                Invalid Records : {InValidRecords}
                              </label>
                              {/* &nbsp; &nbsp;&nbsp;
                              {InValidRecords > 0 ? (
                                <label>
                                  <Link
                                    to={InValidRecordsFilePath}
                                    className="text-primary"
                                  >
                                    Invalid Records File Download
                                  </Link>
                                </label>
                              ) : (
                                ""
                              )}
                              &nbsp; &nbsp;&nbsp;
                              {ValidCount > 0 ? (
                                <label>
                                  <Link
                                    to={ValidRecordsFilePath}
                                    className="text-primary"
                                  >
                                    Valid Records File Download
                                  </Link>
                                </label>
                              ) : (
                                ""
                              )} */}
                            </div>
                          </div>
                        </div>
                      </Row>
                    ) : (
                      ""
                    )}
                    <Row>
                      <Col lg={12}>
                        <div className="card-body p-1">
                          <div className="table-responsive active-projects style-1 shorting">
                            <div
                              id="StandardParameters-tbl_wrapper"
                              className="dataTables_wrapper table-responsive no-footer "
                              style={{ height: "500px", overflowY: "auto" }}
                            >
                              <table
                                id="StandardParameters-tbl"
                                className="table dataTable no-footer mb-0 "
                              >
                                <thead className="fixedheader">
                                  <tr>
                                    <th>Sr. No</th>
                                    <th>Error Message</th>
                                    <th>Department</th>
                                    <th>Test Name</th>
                                    <th>Parameter Name</th>
                                    <th style={{ textAlign: "left" }}>Rate</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {ListOfData?.length > 0 ? (
                                    ListOfData?.filter(
                                      (item, index, self) =>
                                        index ===
                                        self.findIndex(
                                          (t) => t.SRNo === item.SRNo
                                        )
                                    )?.map((item, indx) => {
                                      // Track rendered TestNames for each SRNo
                                      let renderedTestNames = [];

                                      return (
                                        <React.Fragment key={indx}>
                                          {/* Conditional rendering example */}
                                          {ListOfData?.filter(
                                            (x) => x.SRNo === item.SRNo
                                          )?.length > 0 ? (
                                            ListOfData?.filter(
                                              (x) => x.SRNo === item.SRNo
                                            ).map((itemSub, indexSub) => {
                                              // Check if TestName has already been rendered for this SRNo
                                              if (
                                                renderedTestNames.includes(
                                                  itemSub.TestName
                                                )
                                              ) {
                                                return (
                                                  <tr
                                                    key={indexSub}
                                                    style={{
                                                      backgroundColor:
                                                        itemSub?.IsValid ===
                                                        false
                                                          ? "#ffdede"
                                                          : "#e1eae1",
                                                    }}
                                                  >
                                                    {/* Render blank if TestName is a duplicate */}
                                                    <td>
                                                      {indexSub === 0
                                                        ? item.SRNo
                                                        : ""}
                                                    </td>
                                                    <td>
                                                      {itemSub?.ErrorMessage}
                                                    </td>
                                                    <td>
                                                      {indexSub === 0
                                                        ? item.DepartmentName
                                                        : ""}
                                                    </td>
                                                    <td></td> {/* Blank td */}
                                                    <td>
                                                      {itemSub?.ParameterName}
                                                    </td>
                                                    <td
                                                      style={{
                                                        textAlign: "left",
                                                      }}
                                                    >
                                                      {itemSub?.Rate}
                                                    </td>
                                                  </tr>
                                                );
                                              } else {
                                                // Otherwise, render TestName and mark as rendered
                                                renderedTestNames.push(
                                                  itemSub.TestName
                                                );

                                                return (
                                                  <tr
                                                    key={indexSub}
                                                    style={{
                                                      backgroundColor:
                                                        itemSub?.IsValid ===
                                                        false
                                                          ? "#ffdede"
                                                          : "#e1eae1",
                                                    }}
                                                  >
                                                    {/* Conditionally render based on indexSub */}
                                                    <td>
                                                      {indexSub === 0
                                                        ? item.SRNo
                                                        : ""}
                                                    </td>
                                                    <td>
                                                      {itemSub?.ErrorMessage}
                                                    </td>
                                                    <td>
                                                      {indexSub === 0
                                                        ? item.DepartmentName
                                                        : ""}
                                                    </td>
                                                    <td>{itemSub.TestName}</td>
                                                    <td>
                                                      {itemSub?.ParameterName}
                                                    </td>
                                                    <td
                                                      style={{
                                                        textAlign: "left",
                                                      }}
                                                    >
                                                      {itemSub?.Rate}
                                                    </td>
                                                  </tr>
                                                );
                                              }
                                            })
                                          ) : (
                                            // Else case when no records found
                                            <tr>
                                              <td
                                                colSpan={7}
                                                style={{ textAlign: "left" }}
                                              >
                                                {"No Record Found..."}
                                              </td>
                                            </tr>
                                          )}
                                        </React.Fragment>
                                      );
                                    })
                                  ) : (
                                    // No records case
                                    <tr>
                                      <td
                                        colSpan={6}
                                        style={{ textAlign: "left" }}
                                      >
                                        {"No Record Found..."}
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                                ;
                              </table>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Modal.Body>
                  <Modal.Footer></Modal.Footer>
                </Form>
              </FormikProvider>
            </Spin>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default TestMasterRate;
